import pt from 'prop-types';
import { values } from 'lodash/fp';
import { Component } from 'react';

import { LocalizedText } from '@mews/framework';
import { SearchType, TextKey } from '@mews-commander/enums';
import { Button } from '@optimus-web/core';
import { Loader } from '@mews-commander/ui';
import { MoreButtonWrapper } from './style';

interface Props {
    onClick: (type: SearchType) => void;
    type: SearchType;
    isLoading: boolean;
}

export default class MoreButton extends Component<Props> {
    static propTypes = {
        onClick: pt.func.isRequired,
        type: pt.oneOf(values(SearchType)).isRequired,
        isLoading: pt.bool,
    };

    handleClick = (event: React.MouseEvent) => {
        this.props.onClick(this.props.type);
        event.preventDefault();
    };

    render() {
        return (
            <MoreButtonWrapper>
                <Button variant="ghost" onClick={this.handleClick} wide type="submit">
                    {this.props.isLoading ? <Loader size="small" /> : <LocalizedText textKey={TextKey.More} />}
                </Button>
            </MoreButtonWrapper>
        );
    }
}
